import { render } from "./ImportacaoInstitucionalView.vue?vue&type=template&id=59c1f868&scoped=true"
import script from "./ImportacaoInstitucionalView.vue?vue&type=script&lang=js"
export * from "./ImportacaoInstitucionalView.vue?vue&type=script&lang=js"

import "./ImportacaoInstitucionalView.vue?vue&type=style&index=0&id=59c1f868&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD26\\ConfiguradorSistema\\FrontBackEndVue\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59c1f868"]])

export default __exports__